<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex x16>
        <v-card>
          <v-card-title>
            <v-text-field
                v-model="search"
                type="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                class="mr-0"
                @click="openModalCreate"
            >
                New user
            </v-btn>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="users"
                class="elevation-5"
                :pagination.sync="pagination"
                :search="search"
            >
                <template slot="headerCell" slot-scope="props">
                <span>{{ props.header.text }}</span>
                </template>
                <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.role }}</td>
                <td>{{ props.item.client.name }}</td>
                <td>
                    <div class="text-left">
                    <v-btn class="mr-0" icon @click="openModalEdit(props.item)">
                        <v-icon color="primary">edit</v-icon>
                    </v-btn>
                    <v-btn icon @click="openModalDelete(props.item)" v-if="currentUser.role == 'admin'">
                        <v-icon color="red">delete</v-icon>
                    </v-btn>
                    </div>
                </td>
                </template>
            </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <modal-create-user
      v-if="showModalCreate"
      :showModal="showModalCreate"
      @close-modal-create-user="closeModalCreate"
      @update-users="updateUsers"
    ></modal-create-user>
     <modal-edit-user
        v-if="showModalEdit && userSelected"
        :showModal="showModalEdit"
        :user="userSelected"
        @close-modal-edit-user="closeModalEdit"
        @update-users="updateUsers"
      ></modal-edit-user>
      <modal-delete-user
        v-if="showModalDelete && userSelected"
        :showModal="showModalDelete"
        :user="userSelected"
        @close-modal-delete-user="showModalDelete = false"
        @update-users="updateUsers"
      ></modal-delete-user>
  </v-container>
</template>
<script>
import ModalCreateUser from '@/components/commons/users/modals/Create.vue';
import ModalEditUser from '@/components/commons/users/modals/Edit.vue';
import ModalDeleteUser from '@/components/commons/users/modals/Delete.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    ModalCreateUser,
    ModalEditUser,
    ModalDeleteUser
  },
  data () {
    return {
      showModalCreate: false,
      showModalEdit: false,
      showModalDelete: false,
      userSelected: null,
      search: '',
      users: [],
      pagination: {
        rowsPerPage: 25
      },
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Role',
          value: 'role'
        },
        {
          text: 'Company',
          value: 'company'
        },
        {
          text: 'Actions',
          value: false,
          align: 'center'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  watch: {
  },
  mounted () {
    this.loadData();
  },
  methods: {
    openModalCreate () {
      this.showModalCreate = true;
    },
    closeModalCreate () {
      this.showModalCreate = false;
    },
    openModalEdit (user) {
      this.userSelected = user;
      this.showModalEdit = true;
    },
    closeModalEdit () {
      this.userSelected = null;
      this.showModalEdit = false;
    },
    updateUsers () {
      this.userSelected = null;
      this.showModalEdit = false;
      this.showModalCreate = false;
      this.showModalDelete = false;
      this.loadData();
    },
    openModalDelete (user) {
      this.userSelected = user;
      this.showModalDelete = true;
    },
    loadData () {
      this.$store.commit('setLoading', true);
      let url = '/users';
      window.axios.get(url).then((response) => {
        this.users = response.data.data;
        this.$store.commit('setLoading', false);
      });
    },
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
  .color{
    display: block;
    width: 50px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/commons/users/List.vue